import * as React from 'react'
import { useEffect, useState } from 'react'
import RemarkPasswordModal from './RemarkPasswordModal'

// Blocks the badge-scanner detail view (PrintContent + AccessRight) behind a
// password overlay whenever the scanned delegate has an onsite remark. Re-locks
// automatically when a different delegate is scanned. The password is verified
// server-side against the configurable `onsite_remark_password` setting.
const RemarkGate = ({ userId, remark, onCancel, children }) => {
  const [unlocked, setUnlocked] = useState(false)

  // Re-lock whenever a different delegate is scanned.
  useEffect(() => {
    setUnlocked(false)
  }, [userId])

  if (!remark || unlocked) return <>{children}</>

  return (
    <RemarkPasswordModal
      title="Restricted — Onsite Remark"
      remark={remark}
      cancelLabel="Cancel & scan another"
      onSuccess={() => setUnlocked(true)}
      onCancel={onCancel}
    />
  )
}

export default RemarkGate
